import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const UploadDocs = () => {
  const { userid } = useParams();
  const navigate = useNavigate();
  
  const [images, setImages] = useState({
    image0: 'https://singlewindowsecurities.com/assets/kyc/aadhar1.png',
    image1: 'https://singlewindowsecurities.com/assets/kyc/aadhar2.png',
    image2: 'https://singlewindowsecurities.com/assets/kyc/pan.png',
    image3: ''
  });
  const [aadhar, setAadhar] = useState('');
  const [pan, setPan] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const response = await fetch(`https://singlewindowsecurities.com/Rest3/user_details_api/${userid}`);
        const data = await response.json();
        
        setAadhar(data.aadhar || '');
        setPan(data.pan_no || '');
        setImages({
          image0: data.aadhar_doc || 'https://singlewindowsecurities.com/assets/kyc/aadhar1.png',
          image1: data.aadhar_doc2 || 'https://singlewindowsecurities.com/assets/kyc/aadhar2.png',
          image2: data.pan_doc || 'https://singlewindowsecurities.com/assets/kyc/pan.png',
          image3: data.profile_img || ''
        });
      } catch (error) {
        console.error('Error:', error);
      }
    };

    if (userid) {
      fetchUserDetails();
    }
  }, [userid]);

  const pickImage = async (imageKey) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    
    input.onchange = async (e) => {
      const file = e.target.files[0];
      if (!file) return;

      setLoading(true);
      const formData = new FormData();
      formData.append('photo', file);

      try {
        const response = await fetch('https://singlewindowsecurities.com/Rest3/upload_image_api/', {
          method: 'POST',
          body: formData,
        });

        const result = await response.json();
        const imageUrl = `https://singlewindowsecurities.com/assets/kyc/${result.img}`;
        
        setImages(prev => ({ ...prev, [imageKey]: imageUrl }));
      } catch (error) {
        alert('Upload failed');
      } finally {
        setLoading(false);
      }
    };

    input.click();
  };

  const handleSubmit = async () => {
    if (!aadhar || !pan || 
        images.image0.includes('aadhar1.png') || 
        images.image1.includes('aadhar2.png') || 
        images.image2.includes('pan.png')) {
      alert('Please provide all details and documents');
      return;
    }

    setSubmitting(true);
    
    const formData = new FormData();
    formData.append('aadhar', aadhar);
    formData.append('pan_no', pan);
    formData.append('aadhar_doc', images.image0);
    formData.append('aadhar_doc2', images.image1);
    formData.append('pan_doc', images.image2);
    formData.append('profile_img', images.image3);

    try {
      const response = await fetch(`https://singlewindowsecurities.com/Rest3/web_upload_kyc_api/${userid}`, {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();
      alert(result.msg);
      
      if (result.status === 0) {
        if (result.ustatus === "") {
          navigate('/account');
        } else {
          navigate('/login');
        }
      }
    } catch (error) {
      alert('Submission failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container-fluid p-0" style={{ 
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #0d0d0d 100%)'
    }}>
      <div className="container py-4">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-10">
            {/* Header Card */}
            <div className="card rounded-4 mb-4" style={{ 
              background: 'rgba(20, 20, 20, 0.95)',
              border: '1px solid rgba(212, 175, 55, 0.2)',
              backdropFilter: 'blur(10px)'
            }}>
              <div className="card-body p-4 text-center">
                <div className="mb-3">
                  <i className="fa fa-person-badge fs-1" style={{ color: '#D4AF37' }}></i>
                </div>
                <h4 className="mb-2" style={{ color: '#D4AF37', fontWeight: 'bold' }}>
                  <i className="fa fa-shield-check me-2"></i>
                  KYC Verification
                </h4>
                <p style={{ color: '#888' }}>Please provide your KYC documents for account verification</p>
              </div>
            </div>

            {/* Main Form Card */}
            <div className="card rounded-4" style={{ 
              background: 'rgba(20, 20, 20, 0.95)',
              border: '1px solid rgba(212, 175, 55, 0.2)',
              backdropFilter: 'blur(10px)',
              boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)'
            }}>
              <div className="card-body p-4">
                {/* Aadhar Section */}
                <div className="mb-4">
                  <div className="d-flex align-items-center mb-3">
                    <i className="fa fa-credit-card-2-front me-2 fs-5" style={{ color: '#D4AF37' }}></i>
                    <label className="form-label fw-bold mb-0" style={{ color: '#D4AF37', letterSpacing: '1px' }}>
                      AADHAR NUMBER
                    </label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    style={{
                      background: '#1a1a1a',
                      border: '1px solid rgba(212, 175, 55, 0.3)',
                      color: '#fff',
                      borderRadius: '12px',
                      padding: '12px'
                    }}
                    placeholder="Enter 12 digit Aadhar number"
                    maxLength={12}
                    value={aadhar}
                    onChange={(e) => setAadhar(e.target.value)}
                  />
                </div>

                {/* Aadhar Documents */}
                <div className="row mb-4">
                  <div className="col-md-6 mb-3">
                    <button 
                      className="btn w-100 mb-2" 
                      onClick={() => pickImage('image1')}
                      style={{
                        background: 'linear-gradient(145deg, #D4AF37, #B8960C)',
                        border: 'none',
                        color: '#000',
                        fontWeight: 'bold',
                        padding: '10px',
                        borderRadius: '10px'
                      }}
                      disabled={loading}
                    >
                      <i className="fa fa-image me-2"></i>
                      {loading ? 'Uploading...' : 'AADHAR FRONT'}
                    </button>
                    <div className="text-center">
                      <img 
                        src={images.image1} 
                        alt="Aadhar Front" 
                        className="img-fluid rounded" 
                        style={{
                          height: '150px',
                          objectFit: 'cover',
                          border: '2px solid rgba(212, 175, 55, 0.3)',
                          borderRadius: '12px'
                        }} 
                      />
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <button 
                      className="btn w-100 mb-2" 
                      onClick={() => pickImage('image0')}
                      style={{
                        background: 'linear-gradient(145deg, #D4AF37, #B8960C)',
                        border: 'none',
                        color: '#000',
                        fontWeight: 'bold',
                        padding: '10px',
                        borderRadius: '10px'
                      }}
                      disabled={loading}
                    >
                      <i className="fa fa-image me-2"></i>
                      {loading ? 'Uploading...' : 'AADHAR BACK'}
                    </button>
                    <div className="text-center">
                      <img 
                        src={images.image0} 
                        alt="Aadhar Back" 
                        className="img-fluid rounded" 
                        style={{
                          height: '150px',
                          objectFit: 'cover',
                          border: '2px solid rgba(212, 175, 55, 0.3)',
                          borderRadius: '12px'
                        }} 
                      />
                    </div>
                  </div>
                </div>

                {/* PAN Section */}
                <div className="mb-4">
                  <div className="d-flex align-items-center mb-3">
                    <i className="fa fa-card-text me-2 fs-5" style={{ color: '#D4AF37' }}></i>
                    <label className="form-label fw-bold mb-0" style={{ color: '#D4AF37', letterSpacing: '1px' }}>
                      PAN NUMBER
                    </label>
                  </div>
                  <input
                    type="text"
                    className="form-control text-uppercase"
                    style={{
                      background: '#1a1a1a',
                      border: '1px solid rgba(212, 175, 55, 0.3)',
                      color: '#fff',
                      borderRadius: '12px',
                      padding: '12px'
                    }}
                    placeholder="ABCDE1234F"
                    value={pan}
                    onChange={(e) => setPan(e.target.value.toUpperCase())}
                  />
                </div>

                {/* PAN & Selfie Documents */}
                <div className="row mb-4">
                  <div className="col-md-6 mb-3">
                    <button 
                      className="btn w-100 mb-2" 
                      onClick={() => pickImage('image2')}
                      style={{
                        background: 'linear-gradient(145deg, #D4AF37, #B8960C)',
                        border: 'none',
                        color: '#000',
                        fontWeight: 'bold',
                        padding: '10px',
                        borderRadius: '10px'
                      }}
                      disabled={loading}
                    >
                      <i className="fa fa-card-list me-2"></i>
                      {loading ? 'Uploading...' : 'PAN CARD'}
                    </button>
                    <div className="text-center">
                      <img 
                        src={images.image2} 
                        alt="PAN Card" 
                        className="img-fluid rounded" 
                        style={{
                          height: '150px',
                          objectFit: 'cover',
                          border: '2px solid rgba(212, 175, 55, 0.3)',
                          borderRadius: '12px'
                        }} 
                      />
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <button 
                      className="btn w-100 mb-2" 
                      onClick={() => pickImage('image3')}
                      style={{
                        background: 'linear-gradient(145deg, #D4AF37, #B8960C)',
                        border: 'none',
                        color: '#000',
                        fontWeight: 'bold',
                        padding: '10px',
                        borderRadius: '10px'
                      }}
                      disabled={loading}
                    >
                      <i className="fa fa-camera me-2"></i>
                      {loading ? 'Uploading...' : 'PROFILE SELFIE'}
                    </button>
                    <div className="text-center">
                      <img 
                        src={images.image3 || 'https://via.placeholder.com/300x150?text=Upload+Selfie'} 
                        alt="Selfie" 
                        className="img-fluid rounded" 
                        style={{
                          height: '150px',
                          objectFit: 'cover',
                          border: '2px solid rgba(212, 175, 55, 0.3)',
                          borderRadius: '12px'
                        }} 
                      />
                    </div>
                  </div>
                </div>

                {/* Submit Button */}
                <button 
                  className="btn w-100 py-3 fw-bold mt-3" 
                  onClick={handleSubmit} 
                  disabled={submitting || loading}
                  style={{
                    background: 'linear-gradient(145deg, #D4AF37, #B8960C)',
                    border: 'none',
                    color: '#000',
                    fontWeight: 'bold',
                    fontSize: '1rem',
                    letterSpacing: '1px',
                    borderRadius: '12px',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 5px 20px rgba(212, 175, 55, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = 'none';
                  }}
                >
                  {submitting || loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" style={{ color: '#000' }}></span>
                      Processing...
                    </>
                  ) : (
                    <>
                      <i className="fa fa-cloud-upload me-2"></i>
                      SUBMIT KYC DOCUMENTS
                    </>
                  )}
                </button>

                {/* Info Note */}
                <div className="mt-4 pt-3 text-center" style={{ borderTop: '1px solid rgba(212, 175, 55, 0.15)' }}>
                  <small style={{ color: '#888' }}>
                    <i className="fa fa-info-circle me-1" style={{ color: '#D4AF37' }}></i>
                    All documents are encrypted and securely stored
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        ::-webkit-scrollbar {
          width: 6px;
        }
        ::-webkit-scrollbar-track {
          background: #1a1a1a;
          border-radius: 10px;
        }
        ::-webkit-scrollbar-thumb {
          background: #D4AF37;
          border-radius: 10px;
        }
        input:focus {
          box-shadow: 0 0 0 2px rgba(212, 175, 55, 0.3) !important;
          outline: none;
          border-color: #D4AF37 !important;
        }
      `}</style>
    </div>
  );
};

export default UploadDocs;